import { FroalaEditorFunctionality } from './FroalaEditorFunctionality'
import * as React from 'react'

export class FroalaEditor extends FroalaEditorFunctionality {
    // private that: any = this

    render() {
        const that: any = this
        // const Test = this.tag
        return (
            // @ts-ignore
            <that.tag ref={(el) => (that.el = el)}>
                {this.props.children}
            </that.tag>
        )
    }
}
